import { render, staticRenderFns } from "./Listdece.vue?vue&type=template&id=53c193ac&scoped=true"
import script from "./Listdece.vue?vue&type=script&lang=js"
export * from "./Listdece.vue?vue&type=script&lang=js"
import style0 from "./Listdece.vue?vue&type=style&index=0&id=53c193ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c193ac",
  null
  
)

export default component.exports